import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Pet } from "@/types";

export const petsQueryKey = ["pets"] as const;

export function useGetPets() {
  return useQuery({
    queryKey: petsQueryKey,
    queryFn: async () => {
      const path = "pets";
      const res = await guacHttpClient.get<Pet[], HttpResponse<Pet[]>>(path);
      return res.data;
    },
    // Keep other staffers' pets and coin balances fresh in the playyard.
    refetchInterval: 60_000,
  });
}
